module.exports = __webpack_public_path__ + "img/alert.fc762e0c.svg";